import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaArrowRight, FaHome } from 'react-icons/fa';
import { useAdmin } from '../context/AdminContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAdmin();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (login(username, password)) {
      // Login successful
    } else {
      setError('Invalid credentials! Use');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-brand">
          <img
            src="/Sarwa Logo.png"
            alt="Sarwa Group Logo"
            className="brand-logo-img"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <h2>Welcome Back</h2>
          <p className="login-subtitle">Sign in to manage your website</p>

          {error && <div className="login-error">{error}</div>}

          <div className="login-field">
            <FaUser className="login-field-icon" />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="login-field">
            <FaLock className="login-field-icon" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Sign In <FaArrowRight />
          </button>

          {/* HOME BUTTON */}
          <button
            type="button"
            className="home-btn"
            onClick={() => navigate('/')}
          >
            <FaHome /> Back to Home
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;